/* Customização: Store module para silenciar conversas por inbox */
import MuteAPI from '../../api/conversationMute';

const MUTED_CONVERSATIONS_KEY = 'chatwoot_muted_conversations';

// Load from localStorage
const loadMutedFromStorage = () => {
  try {
    const stored = localStorage.getItem(MUTED_CONVERSATIONS_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Failed to load muted conversations from storage:', error);
    return {};
  }
};

// Save to localStorage
const saveMutedToStorage = (mutedConversations) => {
  try {
    localStorage.setItem(MUTED_CONVERSATIONS_KEY, JSON.stringify(mutedConversations));
  } catch (error) {
    console.error('Failed to save muted conversations to storage:', error);
  }
};

export const state = {
  mutedConversations: loadMutedFromStorage(),
  uiFlags: { isMuting: {} },
};

export const getters = {
  isConversationMuted: (state) => (conversationId) => {
    return state.mutedConversations[conversationId] || false;
  },
  getUIFlags: (state) => state.uiFlags,
};

export const actions = {
  async fetchMuteStatus({ commit }, conversationId) {
    try {
      const response = await MuteAPI.show(conversationId);
      commit('SET_MUTE_STATUS', {
        conversationId,
        muted: response.data.muted,
      });
    } catch (error) {
      console.error('Failed to fetch mute status:', error);
    }
  },

  async muteConversation({ commit }, conversationId) {
    commit('SET_MUTING_STATUS', { conversationId, status: true });
    try {
      await MuteAPI.mute(conversationId);
      commit('SET_MUTE_STATUS', { conversationId, muted: true });
    } catch (error) {
      console.error('Failed to mute:', error);
      throw error;
    } finally {
      commit('SET_MUTING_STATUS', { conversationId, status: false });
    }
  },

  async unmuteConversation({ commit }, conversationId) {
    commit('SET_MUTING_STATUS', { conversationId, status: true });
    try {
      await MuteAPI.unmute(conversationId);
      commit('SET_MUTE_STATUS', { conversationId, muted: false });
    } catch (error) {
      console.error('Failed to unmute:', error);
      throw error;
    } finally {
      commit('SET_MUTING_STATUS', { conversationId, status: false });
    }
  },
};

export const mutations = {
  SET_MUTE_STATUS(state, { conversationId, muted }) {
    state.mutedConversations = {
      ...state.mutedConversations,
      [conversationId]: muted,
    };
    // Save to localStorage
    saveMutedToStorage(state.mutedConversations);
  },

  SET_MUTING_STATUS(state, { conversationId, status }) {
    state.uiFlags.isMuting = {
      ...state.uiFlags.isMuting,
      [conversationId]: status,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
